import { useState} from "react";
import { useDispatch } from "react-redux";
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import FormInput from "../FormInput/FormInput";
import FormTextarea from "../FormTextarea/FormTextarea";
import styles from "./FeedbackModal.module.css";


export default function FeedbackModal() {
    const dispatch = useDispatch();

    const handleClose = function() {
        dispatch(uiActions.setFeedbackModalActive(false));
        dispatch(uiActions.setPopUpModalActive(false))
    } 
 

    const [formValidity, setFormValidity] = useState({});

    const checkFormValidity = () => {
        for (let key in formValidity) {
            if (!formValidity[key]) {
                document.getElementById(key).focus();
                document.getElementById(key).blur();
                return false;
            }
        }
        return true;
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        if(checkFormValidity()){
            const data = new FormData(event.target);
            const dataObj = data.entries();
            const formData = {};
            dataObj.forEach((arry, key) => {
                formData[arry[0]] = arry[1]
            });
            try {
                const response = await fetch('/services/email.ashx', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });

                if (response.ok) {
                    // Handle success
                    console.log('Form submitted successfully');
                    handleClose();
                } else {
                    // Handle error
                    console.error('Form submission failed');
                }
            } catch (error) {
                console.error('Error submitting form:', error);
            }
        }
    };

    return (
        <>
        <PopUpModal handleClose={handleClose}>
            <div className={styles.container}>
                        <h2>Feedback</h2>
                        <p>Please send us any questions or comments you may have.</p>
                        <form onSubmit={handleSubmit}>
                            <FormInput
                                id="fromEmail"
                                label="Email Address"
                                type="email"
                                required={true}
                                errorMsg={"Enter valid email address. ex - someone@example.com"}
                                pattern={/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/}
                                setFormValidity={setFormValidity}
                            />
                            <FormTextarea
                                id="body"
                                label="Message"
                                defaultText=""
                                required={true}
                                errorMsg={"Only letters and spaces allowed"}
                                pattern={/.*/}
                                setFormValidity={setFormValidity}
                            />
                            <button type="submit">Send</button>
                            <button type="button" className={styles.blueBack} onClick={handleClose}>Cancel</button>
                        </form>
                    </div>
        </PopUpModal>
        </>
    );
}
